<template>
  <div class="footern">
    <div class="footer-content">
      <div class="left-float">
        <a href="https://www.instagram.com/huaweisverige/" target="_blank"><i class="fa fa-instagram"></i></a>
        <a href="https://twitter.com/Honorglobal" target="_blank"><i class="fa fa-twitter"></i></a>
        <a href="https://www.facebook.com/huawei/" target="_blank"><i class="fa fa-facebook"></i></a>
        <a href="https://www.youtube.com/user/HuaweiSverige" target="_blank"><i class="fa fa-youtube"></i></a>
      </div>
      <a href="http://www.huawei.com"><img src="./../assets/img/pbhlogo-min.png" width="170"></a>
      <div class="right-float">
        COPYRIGHT ©HUAWEI HONOR 1998-2017.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footern',
  computed: {
  }
}
</script>

<style scoped>
  a {
    color: inherit;
    text-decoration: inherit;
  }
  .footern {
    text-align: center;
    background-color: #02b4e5;
    color: #fff;
    box-sizing: border-box;
    padding: 30px;
    padding-bottom: 20px;
    margin-top: 50px;
  }
  .footer-content {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    text-align: center;
  }
  .right-float {
    float: right;
    font-size: 14px;
    padding-top: 16px;
    letter-spacing: 1px;
  }
  .left-float {
    float: left;
    font-size: 20px;
  }
  i {
    padding-top: 8px;
    margin: 10px;
  }
  @media only screen and (max-width: 900px) {
    .right-float, .left-float {
      float: none;
      display: block;
      margin-bottom: 30px;
    }
    .right-float {
      font-size: 12px;
    }

  }
</style>



// WEBPACK FOOTER //
// Footern.vue?a4095e08